import React, { useEffect, useState } from 'react';
import CompanyListDumb from './CompanyListDumb';
import queryString from 'query-string';
import { withRouter, useHistory, useLocation } from 'react-router-dom';
import { useList, useCompany } from 'components/hooks';
import { Alert, ModalAlert, ErrorScreen } from 'components/common';
import withRequest from 'hoc/withRequest';
import { ROUTES } from 'consts';

const CompanyListSmart = (props) => {
  const { getContentList, content, error, isLoaded } = useList('companies');
  const company = useCompany();
  const history = useHistory();
  const location = useLocation();
  const [openModal, setOpenModal] = useState(false);
  const [companySelected, setCompanySelected] = useState(null);
  let { search } = queryString.parse(props.location.search);

  const handleListPage = () => {
    const query = {}
    if (search) {
      query.search = search;
    }
    getContentList({ query });
  };

  const handleCleanUp = () => {
    company.cleanUpMessage();
  }

  const handleSearch = (data) => {
    const {pathname, search} = location;
    const currentLocation = `${pathname}${search}`;
    let routeToPush = `${ROUTES.COMPANY_LIST}`;
    if (data.search !== '') {
      routeToPush = `${routeToPush}?search=${data.search}`
    }
    if (currentLocation === routeToPush) {
      handleListPage();
    } else {
      history.push(routeToPush);
    }
  };

  const handleCreate = () => {
    handleCleanUp();
    history.push(ROUTES.COMPANY_CREATE);
  };

  const handleEdit = (company) => {
    handleCleanUp();
    history.push(`${ROUTES.COMPANY_EDIT}/${company.company_id}`);
  };

  const handleDelete = () => {
    const { company_id } = companySelected;
    company.deleteCompany({
      body: { company_id },
    });
    setOpenModal(false);
  };

  const handleModalDelete = (company) => {
    setCompanySelected(company);
    setOpenModal(true);
  };

  const alerts = [
    {
      severity: 'success',
      open: company.success.post,
      message: 'companyList.components.alert.success',
    },
    {
      severity: 'success',
      open: company.success.delete,
      message: 'companyList.components.alert.deleteSuccess',
    },
    {
      severity: 'info',
      open: company.success.put,
      message: 'companyList.components.alert.putSuccess',
    },
    {
      severity: 'error',
      open: company.error.put,
      message: 'companyList.components.alert.error',
    },
    {
      severity: 'error',
      open: company.error.delete,
      message: 'companyList.components.alert.error',
    },
    {
      severity: 'error',
      open: company.error.post,
      message: 'companyList.components.alert.error',
    },
  ];

  useEffect(() => {
    handleListPage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  useEffect(() => {
    if (
      company.success.get ||
      company.success.post ||
      company.success.put ||
      company.success.delete
    ) {
      handleListPage();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    company.success.get,
    company.success.post,
    company.success.put,
    company.success.delete,
  ]);

  return (
    <>
      { error ? (
        <ErrorScreen />
      ) : (
        <CompanyListDumb
          handleSearch={handleSearch}
          searchValue={search}
          handleCreate={handleCreate}
          handleEdit={handleEdit}
          handleDelete={handleModalDelete}
          content={content}
          isLoaded={isLoaded}
        />
      )}

      { alerts.map((alert, index) => (
        <Alert
          key={index}
          severity={alert.severity}
          handleClose={() => company.cleanUpMessage()}
          open={alert.open}
          message={alert.message}
        />
      ))}

      <ModalAlert
        open={openModal}
        handleClose={() => setOpenModal(false)}
        handleConfirm={handleDelete}
      />
    </>
  );



}

export default withRequest(withRouter(CompanyListSmart));
